import ModelFactoryChoice, {IModelFactoryChoices} from "./ModelFactoryChoice";

export default class ModelFactoryService
{

    constructor()
    {

    }

    createChoiceList(choices:IModelFactoryChoices, choiceOrder:string[]): ModelFactoryChoice[]
    {
        const choiceList:ModelFactoryChoice[] = [];
        for(let i = 0; i < choiceOrder.length; i ++) {
            let choiceID = choiceOrder[i];
            if(choiceOrder.indexOf(choiceID) < i){
                continue;
            }
            let choice = choices[choiceID];
            if(choice){
                choiceList.push(choice);
            }
        }
        return choiceList;
    }
}